module.exports = class ProductBrandsListCtrl
  constructor: ->
    'ngInject'

  $onInit: ->
    @updateTable = @updateTable.bind(@)

  updateTable: ->
    @onRefresh()
